// <auto-generated />
// ATENCAO: Arquivo auto-gerado pelo SetupController. Nao altere manualmente.

export const SUP_ST_DOC_ENT = {
  EmDigitao: 'SUP_ST_DOC_ENT1',
  Aprovado: 'SUP_ST_DOC_ENT2',
  Cancelado: 'SUP_ST_DOC_ENT3',
  // Mapa de sequencia (SequenciaLista) para lookup por codigo
  sequencia: {
    SUP_ST_DOC_ENT1: 1,
    SUP_ST_DOC_ENT2: 2,
    SUP_ST_DOC_ENT3: 3
  }
}
